<div class="form-actions">
  @if (step() === 'first') {
    <button mat-flat-button color="primary" type="submit" [disabled]="isFormInvalid()" (click)="onContinue()">Continue</button>
  }
  @if (step() === 'last') {
    <button mat-stroked-button type="button" (click)="onBack()">Back</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="isFormInvalid()" (click)="onFinish()">Finish</button>
  }
  @if (step() === undefined) {
    <button mat-stroked-button type="button" (click)="onBack()">Back</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="isFormInvalid()" (click)="onContinue()">Continue</button>
  }
</div>